"use client";

import type { RefObject } from "react";
import type { Swiper as SwiperType } from "swiper";

import { CarouselCenteredNavButton } from "@/components/carouselCentered/carouselCenteredNavButton.component";
import { Text } from "@/components/text/text.component";

export const SuggestedForYouHeader = ({
  swiperRef,
  title,
  totalPages = 0,
}: SuggestedForYouHeaderProps) => {
  const heading = title?.trim() || "Suggested for you";
  const showDesktopNav = totalPages > 1;

  return (
    <>
      <div className="mb-6 hidden grid-cols-3 items-center lg:grid">
        <div />
        <Text variant="h3" component="h2" className="text-center">
          {heading}
        </Text>
        {showDesktopNav ? (
          <div className="flex justify-end gap-4">
            <CarouselCenteredNavButton swiperRef={swiperRef} direction="prev" />
            <CarouselCenteredNavButton swiperRef={swiperRef} direction="next" />
          </div>
        ) : (
          <div />
        )}
      </div>
      <Text variant="h3" component="h2" className="mb-6 text-center lg:hidden">
        {heading}
      </Text>
    </>
  );
};

export type SuggestedForYouHeaderProps = {
  swiperRef: RefObject<SwiperType | null>;
  title?: string;
  totalPages?: number;
};
